import { animate, timeline as timeline2, stagger } from "{{ 'vendor.min.js' | asset_url }}";

(function (window, k) {
    $(document).ready(function() {
        var pathname = window.location.pathname;
        var email;

        if (pathname.includes("/cart")) {
            // Função para verificar e ajustar o estado do botão
            function updateButtonState() {
                $(".subscription-has-active-sub").hide();
                $(".subscription-has-inactive-sub").hide();
                $("#has_active_or_inactive_sub").hide();
                $("#verify_if_email_has_sub").show();
                email = $("#subscription_verification").val();
                if (!email) {
                    $("#verify_if_email_has_sub").attr("disabled", true).addClass('disabled-custom');
                } else {
                    $("#verify_if_email_has_sub").attr("disabled", false).removeClass('disabled-custom');
                }
            }

            // Chama a função imediatamente para definir o estado inicial do botão
            updateButtonState();

            // Evento de input para atualizar o estado do botão conforme o usuário digita
            $("#subscription_verification").on("input", updateButtonState);

            // Evento de clique do botão
            $("#verify_if_email_has_sub").on("click", async function() {
                var $button = $(this);
                var $contentElement = $button.find('div');
                $contentElement.addClass("checkout-style-btn");
                var $animationElement = $button.find('.button__loader');

                timeline2([
                    [$contentElement, { transform: ["translateY(0)", "translateY(-10px)"], opacity: 0 }, { duration: 0.15 }],
                    [$animationElement, { transform: ["translateY(10px)", "translateY(0)"], opacity: 1 }, { duration: 0.15 }]
                  ]);
                animate($animationElement.children().get(), { opacity: [1, 0.1] }, { duration: 0.35, delay: stagger(0.35 / 3), direction: "alternate", repeat: Infinity });
                $contentElement.html('<svg role="presentation" fill="none" focusable="false" stroke-width="1.2" width="18" height="18" class="icon icon-picto-lock" viewBox="0 0 24 24"><path d="M3.236 18.182a5.071 5.071 0 0 0 4.831 4.465 114.098 114.098 0 0 0 7.865-.001 5.07 5.07 0 0 0 4.831-4.464 23.03 23.03 0 0 0 .165-2.611c0-.881-.067-1.752-.165-2.61a5.07 5.07 0 0 0-4.83-4.465c-1.311-.046-2.622-.07-3.933-.069a109.9 109.9 0 0 0-3.933.069 5.07 5.07 0 0 0-4.83 4.466 23.158 23.158 0 0 0-.165 2.609c0 .883.067 1.754.164 2.61Z" fill="currentColor" fill-opacity=".12" stroke="currentColor"></path><path d="M17 8.43V6.285A5 5 0 0 0 7 6.286V8.43" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path d="M12 17.714a2.143 2.143 0 1 0 0-4.286 2.143 2.143 0 0 0 0 4.286Z" stroke="currentColor"></path></svg>Checkout');

                email = $("#subscription_verification").val();
                var isCustomer = await checkIfCustomerExists(email);

                if (isCustomer.length == 0) {
                    $(".sub-verification").hide();
                    $("#checkout_button").show();
                    timeline2([
                        [$animationElement, { transform: ["translateY(0)", "translateY(-10px)"], opacity: 0 }, { duration: 0.15 }],
                        [$contentElement, { transform: ["translateY(10px)", "translateY(0)"], opacity: 1 }, { duration: 0.15 }]
                      ]);
                      $contentElement.html('<svg role="presentation" fill="none" focusable="false" stroke-width="1.2" width="18" height="18" class="icon icon-picto-lock" viewBox="0 0 24 24"><path d="M3.236 18.182a5.071 5.071 0 0 0 4.831 4.465 114.098 114.098 0 0 0 7.865-.001 5.07 5.07 0 0 0 4.831-4.464 23.03 23.03 0 0 0 .165-2.611c0-.881-.067-1.752-.165-2.61a5.07 5.07 0 0 0-4.83-4.465c-1.311-.046-2.622-.07-3.933-.069a109.9 109.9 0 0 0-3.933.069 5.07 5.07 0 0 0-4.83 4.466 23.158 23.158 0 0 0-.165 2.609c0 .883.067 1.754.164 2.61Z" fill="currentColor" fill-opacity=".12" stroke="currentColor"></path><path d="M17 8.43V6.285A5 5 0 0 0 7 6.286V8.43" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path d="M12 17.714a2.143 2.143 0 1 0 0-4.286 2.143 2.143 0 0 0 0 4.286Z" stroke="currentColor"></path></svg>Checkout');
                } else {
                    var customerTagsString = isCustomer[0].tags;
                    var customerTags = customerTagsString.split(", ").map(tag => tag.trim());

                    if(!customerTags.includes("appstle_subscription_active_customer") && !customerTags.includes("appstle_subscription_inactive_customer")) {
                        $(".sub-verification").hide();
                        $("#checkout_button").show();
                        timeline2([
                            [$animationElement, { transform: ["translateY(0)", "translateY(-10px)"], opacity: 0 }, { duration: 0.15 }],
                            [$contentElement, { transform: ["translateY(10px)", "translateY(0)"], opacity: 1 }, { duration: 0.15 }]
                          ]);
                        $contentElement.html('<svg role="presentation" fill="none" focusable="false" stroke-width="1.2" width="18" height="18" class="icon icon-picto-lock" viewBox="0 0 24 24"><path d="M3.236 18.182a5.071 5.071 0 0 0 4.831 4.465 114.098 114.098 0 0 0 7.865-.001 5.07 5.07 0 0 0 4.831-4.464 23.03 23.03 0 0 0 .165-2.611c0-.881-.067-1.752-.165-2.61a5.07 5.07 0 0 0-4.83-4.465c-1.311-.046-2.622-.07-3.933-.069a109.9 109.9 0 0 0-3.933.069 5.07 5.07 0 0 0-4.83 4.466 23.158 23.158 0 0 0-.165 2.609c0 .883.067 1.754.164 2.61Z" fill="currentColor" fill-opacity=".12" stroke="currentColor"></path><path d="M17 8.43V6.285A5 5 0 0 0 7 6.286V8.43" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path d="M12 17.714a2.143 2.143 0 1 0 0-4.286 2.143 2.143 0 0 0 0 4.286Z" stroke="currentColor"></path></svg>Checkout');
                    }

                    if(customerTags.includes("appstle_subscription_active_customer")) {
                        $(".subscription-has-active-sub").show();
                        $button.hide();
                        $("#has_active_or_inactive_sub").show();
                        timeline2([
                            [$animationElement, { transform: ["translateY(0)", "translateY(-10px)"], opacity: 0 }, { duration: 0.15 }],
                            [$contentElement, { transform: ["translateY(10px)", "translateY(0)"], opacity: 1 }, { duration: 0.15 }]
                          ]);
                        $contentElement.html('<svg role="presentation" fill="none" focusable="false" stroke-width="1.2" width="18" height="18" class="icon icon-picto-lock" viewBox="0 0 24 24"><path d="M3.236 18.182a5.071 5.071 0 0 0 4.831 4.465 114.098 114.098 0 0 0 7.865-.001 5.07 5.07 0 0 0 4.831-4.464 23.03 23.03 0 0 0 .165-2.611c0-.881-.067-1.752-.165-2.61a5.07 5.07 0 0 0-4.83-4.465c-1.311-.046-2.622-.07-3.933-.069a109.9 109.9 0 0 0-3.933.069 5.07 5.07 0 0 0-4.83 4.466 23.158 23.158 0 0 0-.165 2.609c0 .883.067 1.754.164 2.61Z" fill="currentColor" fill-opacity=".12" stroke="currentColor"></path><path d="M17 8.43V6.285A5 5 0 0 0 7 6.286V8.43" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path d="M12 17.714a2.143 2.143 0 1 0 0-4.286 2.143 2.143 0 0 0 0 4.286Z" stroke="currentColor"></path></svg>Checkout');

                    }

                    if(customerTags.includes("appstle_subscription_inactive_customer")) {
                        $(".subscription-has-inactive-sub").show();
                        $button.hide();
                        $("#has_active_or_inactive_sub").show();
                        timeline2([
                            [$animationElement, { transform: ["translateY(0)", "translateY(-10px)"], opacity: 0 }, { duration: 0.15 }],
                            [$contentElement, { transform: ["translateY(10px)", "translateY(0)"], opacity: 1 }, { duration: 0.15 }]
                          ]);
                        $contentElement.html('<svg role="presentation" fill="none" focusable="false" stroke-width="1.2" width="18" height="18" class="icon icon-picto-lock" viewBox="0 0 24 24"><path d="M3.236 18.182a5.071 5.071 0 0 0 4.831 4.465 114.098 114.098 0 0 0 7.865-.001 5.07 5.07 0 0 0 4.831-4.464 23.03 23.03 0 0 0 .165-2.611c0-.881-.067-1.752-.165-2.61a5.07 5.07 0 0 0-4.83-4.465c-1.311-.046-2.622-.07-3.933-.069a109.9 109.9 0 0 0-3.933.069 5.07 5.07 0 0 0-4.83 4.466 23.158 23.158 0 0 0-.165 2.609c0 .883.067 1.754.164 2.61Z" fill="currentColor" fill-opacity=".12" stroke="currentColor"></path><path d="M17 8.43V6.285A5 5 0 0 0 7 6.286V8.43" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path d="M12 17.714a2.143 2.143 0 1 0 0-4.286 2.143 2.143 0 0 0 0 4.286Z" stroke="currentColor"></path></svg>Checkout');
                    }
                }
            });

            async function checkIfCustomerExists(email) {
                try {
                    const data = await makeRequestAPI(`admin/api/2024-04/customers/search.json?query=email:${email}`, 'GET');
                    if (data !== null) {
                        return data.customers;
                    }

                    return [];
                } catch (error) {
                    console.error('Erro ao obter informações do cliente:', error);
                    return 0;
                }
            }

            function makeRequestAPI(endpoint, method, data = null) {
                const url = `https://dev.escolhadigital.com/Homecooks/shopify-api.php?endpoint=${endpoint}&method=${method}`;

                var options = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                };

                if (method === 'POST' && data) {
                    options.method = 'POST';
                    options.body = JSON.stringify(data);
                }

                return fetch(url, options)
                    .then(response => {
                        if (!response.ok) {
                            throw new Error('Erro ao fazer requisição para a API');
                        }
                        return response.json();
                    })
                    .then(data => {
                        return data;
                    })
                    .catch(error => {
                        console.error('Erro:', error);
                        return null;
                    });
            }
        }
    });
})(window);
